import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const LetterSpacingUnit = z.enum(["Pixels", "Rem", "Percent"]);
export const LetterSpacingValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const LetterSpacingTokenData = tokenAliasOrValue(LetterSpacingValue);
